export const AGENCY_LOGIN_AS_BEGIN = 'syftacp/__NO_POST__/AGENCY_LOGIN_AS_BEGIN'
export const AGENCY_LOGIN_AS_FAILED = 'syftacp/__NO_POST__/AGENCY_LOGIN_AS_FAILED'
export const AGENCY_LOGIN_AS_SUCCEEDED = 'syftacp/__NO_POST__/AGENCY_LOGIN_AS_SUCCEEDED'
